/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';

import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, RouterModule, Routes } from '@angular/router';
import { Subscription } from 'rxjs';
import { WorkspaceTabPipe } from '../../utils/pipes/workspace-tab.pipe';
import { MatCardModule } from '@angular/material/card';
import { Workspace } from '@workspaces/models/workspaces';
import { AppState } from 'src/app/state/app.state';
import { Store } from '@ngrx/store';
import { WorkspaceFetch, workspaceListFeature } from '@workspaces/store/workspace-list.feature';

import { WorkspaceSocketService } from '@workspaces/utils/workspace-socket.service';

interface AppTab {
  label: string;
  pathSegment: string;
}
@Component({
  selector: 'app-workspace-tab',
  templateUrl: './workspace-tab.component.html',
  styleUrls: ['./workspace-tab.component.scss'],
  standalone: true,
  imports: [CommonModule, MatTabsModule, MatCardModule, RouterModule, WorkspaceTabPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkspaceTabComponent implements OnInit, OnDestroy {
  public isEditMode = false;

  public currentTabs: AppTab[] = [];
  public baseRoute: string[] = [];
  public currentWorkspace: Workspace | null = null;
  public workspaceId: string | null = null;
  private readonly sub = new Subscription();
  constructor(
    private readonly route: ActivatedRoute,
    private readonly store: Store<AppState>,
    private readonly workspaceSocketService: WorkspaceSocketService
  ) {}

  ngOnInit(): void {
    this.sub.add(
      this.route.paramMap.subscribe(params => {
        this.workspaceId = params.get('workspaceId') ?? null;
        this.isEditMode = !!this.workspaceId;
        const modeSegment = this.isEditMode ? this.workspaceId : 'create';

        this.workspaceSocketService.setCurrentlyOpenedWorkspace(this.workspaceId);

        if (this.workspaceId) {
          this.workspaceSocketService.subscribeToWorkspace(this.workspaceId);
        }
        this.baseRoute = ['/workspaces', modeSegment!];
        this.loadTabsFromRouteConfig();
        this.loadWorkspace();
      })
    );
  }

  private loadWorkspace() {
    if (this.workspaceId) {
      this.sub.add(
        this.store.select(workspaceListFeature.workspaceById(this.workspaceId)).subscribe(workspace => {
          if (this.workspaceId === workspace?.id && workspace) {
            this.currentWorkspace = workspace;
          }
        })
      );
      this.store.dispatch(WorkspaceFetch({ workspaceId: this.workspaceId }));
    }
  }

  private loadTabsFromRouteConfig(): void {
    const parentConfig = this.route.routeConfig;

    if (parentConfig?.children) {
      this.currentTabs = (parentConfig.children as Routes)
        .filter(childRoute => childRoute.data?.['tabTitle'])
        .map(childRoute => {
          return {
            label: childRoute.data?.['tabTitle'],
            pathSegment: childRoute.path!
          };
        });
    }
  }
  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
